/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';

const WHITEPAPER_URL = 'https://wli.divirod.com/methodology.pdf';

export default function AboutText() {
  return (
    <div className="about-text">
      <p>
        Explore Divirod&apos;s Water Level Index (WLI) Map for a visual representation of global
        water conditions based on real data, distinguishing it from model estimates. The map,
        continuously updated, categorizes water levels into five codes and provides insights into
        areas at risk of excess or scarcity. The methodology details can be found in
        <a target="_blank" rel="noreferrer" href={WHITEPAPER_URL}> this white paper</a>.
        For detailed data access, contact
        <a href="mailto:water.team@divirod.com"> water.team@divirod.com</a>.
      </p>
    </div>
  );
}
